var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 45,
    viewBox: "0 0 108 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 107,
    height: 44,
    rx: 3.5,
    stroke: "#B5B8B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#B5B8B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 33,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 87,
    height: 6,
    rx: 3,
    fill: "#B5B8B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 87,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 87,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 33,
    width: 87,
    height: 6,
    rx: 3,
    fill: "#DDDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.fca3d0ba51630a7690ea3cda89851e66.svg";
export { ForwardRef as ReactComponent };